
import React from 'react';
import { AlertCircle } from 'lucide-react';

const ProblemGrid = () => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 mb-12 sm:mb-16 md:mb-20">
      <div className="group">
        <div className="h-full bg-white border border-red-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 md:p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
          <div className="flex items-start gap-4 sm:gap-6">
            <div className="flex-shrink-0">
              <div className="w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 bg-red-100 rounded-lg sm:rounded-xl flex items-center justify-center group-hover:bg-red-200 transition-colors">
                <AlertCircle className="text-red-600" size={20} />
              </div>
            </div>
            <div className="flex-grow">
              <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-900 mb-2 sm:mb-3 md:mb-4">The Struggle Is Real</h3>
              <p className="text-gray-700 leading-relaxed text-sm sm:text-base md:text-lg">
                Many talented agency owners – dedicated experts like you – are brilliant at their craft but find the prospecting and sales side of things to be a constant source of stress and avoidance.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="group">
        <div className="h-full bg-white border border-orange-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 md:p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
          <div className="flex items-start gap-4 sm:gap-6">
            <div className="flex-shrink-0">
              <div className="w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 bg-orange-100 rounded-lg sm:rounded-xl flex items-center justify-center group-hover:bg-orange-200 transition-colors">
                <AlertCircle className="text-orange-600" size={20} />
              </div>
            </div>
            <div className="flex-grow">
              <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-900 mb-2 sm:mb-3 md:mb-4">Commoditized Services</h3>
              <p className="text-gray-700 leading-relaxed text-sm sm:text-base md:text-lg">
                Meanwhile, you see the market shifting, and you're probably feeling the pressure of offering the same "commoditized" services as countless others. Web design? SEO? Lead Gen? Reputation Management?
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProblemGrid;
